/* eslint-disable max-len */
/* eslint-disable react/jsx-key */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { string, any, objectOf, func, object, bool, element } from 'prop-types';
import { get, isEmpty } from 'lodash';
import queryString from 'query-string';
// import SponsorsBand from '../molecules/sponsors-band';
import CardImage from '../atoms/cardimage';
import Footer from '../story/footer/footer';
import Authors from '../story/authors/authors';
import PublishedInfo from '../story/published-info/published-info';
import Share from '../story/share/share';
import OpinionBadge from '../story/opinion-badge/opinion-badge';
import ShareFloatingExpanded from '../story/share/share-floating-expanded';
import WithMember from '../hoc/with-member';
import AmazonPolly from './amazon-polly';
import { hasSection,isStoryExclusive } from '../../helpers/story-helpers';
import {
  syndicatedSource,
  checkCookie,
  getStaticConfig,
  getStoryDate,
  getSection
} from '../../helpers/utils';
import { trackUserInteraction } from '../../helpers/datalayer-utils';
import SvgIcon from '../atoms/svg-icon';
import './premium-story.m.css';
import BreadcrumbBasic from '../atoms/breadcrumb-basic';
import Slider from 'react-slick';
import RightArrowSmall from '../atoms/icons/right-arrow-small';
import LeftArrowSmall from '../atoms/icons/left-arrow-small';
import StoryCardVerticalWithImageDate from '../molecules/story-card/story-card-vertical-with-image-date';
import VideosWidget from '../molecules/videos-widget';
import VideoTitle from '../molecules/titles/videos';
import TrackVisibility from '../track-visibility';
// import DavosBand from '../molecules/davos-band';
import { BQLink } from '../atoms/bqlink';
import { ClockOutlineIcon } from '../atoms/material-icons';
import ContentNotAvailable from '../story/contentnotavailable/contentnotavailable';
import MailmodoNewsLetter from '../molecules/newsletter/mailmodo-news-letter';
import MoreLikeThisWidget from '../story/more-like-this-widget';
import storyElementWithCustomTemplates from '../story/story-elements';
import ExclusivesStorySliderWidget from '../collection-templates/exclusives-story-slider-widget';

function changeSymbolColor(element) {
  const newElement = { ...element };
  if (newElement.type === 'text') {
    newElement.text = newElement.text.replace(/♥|♦/gi, function (matched) {
      return `<span style="color:red;">${matched}</span>`;
    });
  }
  return newElement;
}

const storyShareClickHandler = (storyContentId, storyUrl) => (event) =>
  global.app.registerStoryShare(
    storyContentId,
    event.currentTarget.getAttribute('data-social-media-type'),
    storyUrl
  );

function addLinkToCopy() {
  var bodyElement = document.getElementsByTagName('body')[0];
  var selection = window.getSelection();
  var pagelink =
    "<br /><br /> Read more at: <a href='" +
    document.location.href +
    "'>" +
    document.location.href +
    '</a><br />Copyright &copy; NDTV Profit';
  var copytext = selection.toString().substring(0, 400) + pagelink;
  var newdiv = document.createElement('div');
  newdiv.style.position = 'absolute';
  newdiv.style.left = '-99999px';
  bodyElement.appendChild(newdiv);
  newdiv.innerHTML = copytext;
  selection.selectAllChildren(newdiv);
  window.setTimeout(function () {
    bodyElement.removeChild(newdiv);
  }, 0);
}

const PremiumStory = (props) => {
  const [isGeoBlock, setIsGeoBlock] = useState(false);
  const [topIndices, setTopIndices] = useState([]);
  const [showFloatingSocial, setShowFloatingSocial] = useState(false);
  const [premium, setPremium] = useState(null);

  useEffect(() => {
    // TODO: Reset function when unmounting
    document.oncopy = addLinkToCopy;
    const queryObject = queryString.parse(window.location.search);

    if (queryObject.utm_source === 'wru') {
      const datalayerFields = {
        category: 'article page',
        action: 'Recommended for you',
        label: get(props, ['story', 'headline'], ''),
        event: 'event articlepage',
        cd22: 'link',
        cd23: 'bottom more on this topic',
        cd24: 'NA', // element id
        cd26: syndicatedSource(get(props, 'story', null)),
        cd31: get(props, ['story', 'story-template'], 'text'),
        cd35: 'wru',
        cd34: 'NA', // source of the user
      };
      trackUserInteraction(datalayerFields);
    }
    if (window.history.length === 1) {
      const _datalayerFields = {
        event: 'event Back button clicked',
        label: 'back button',
        action: 'click',
      };
      (function (window, location) {
        history.replaceState(null, document.title, location.pathname + '#!/homepage');
        history.pushState(null, document.title, location.pathname);

        window.addEventListener(
          'popstate',
          function () {
            if (location.hash === '#!/homepage') {
              history.replaceState(null, document.title, location.pathname);
              trackUserInteraction(_datalayerFields);
              setTimeout(function () {
                location.replace('https://www.ndtvprofit.com/');
              }, 0);
            }
          },
          false
        );
      })(window, location);
    }

    const GeoTag = checkCookie('GeoTag');
    const syndicatesource = syndicatedSource(props.story);
    const sectionSlug = get(props, ['story', 'sections']).map((item) => item.slug);
    // const isDateCheck = isBefore(
    //   new Date(get(props, ['story', 'first-published-at'])),
    //   new Date('05-05-2022')
    // );

    const sources = get(
      getStaticConfig,
      ['integrations', 'geoTag', 'sources'],
      ['Bloomberg', 'businessweek', 'bloomberg']
    );
    const sourceCheck =
      sources.includes(syndicatesource) || sectionSlug.some((val) => sources.includes(val));
    setIsGeoBlock(
      GeoTag &&
        GeoTag !== 'undefined' &&
        GeoTag !== 'IN' &&
        // !isDateCheck &&
        sourceCheck
    );

    if (window.location.pathname.includes('research-reports')) {
      window.localStorage.setItem(
        'storyInfo',
        JSON.stringify({
          type: 'text',
          authorName: props?.story?.['author-name'],
        })
      );
    } else {
      window.localStorage.removeItem('storyInfo');
    }
  }, []);

  const renderCards = (story = {}, storyCards = [], preview = false) => {
    const cardLength = storyCards.length;
    return (
      <React.Fragment>
        {storyCards.map((card, index) => {
          const cardAttributeTemplate = get(card, ['metadata', 'attributes', 'template', 0], '');
          const cardAttributeTicker = get(card, ['metadata', 'attributes', 'ticker'], []);
          const classes = cardAttributeTemplate ? `story-card-${cardAttributeTemplate}` : '';
          const storyStyleType = get(story, ['metadata', 'story-attributes', 'storystyletype', 0]);
          const storyElements = card['story-elements'];

          return (
            <React.Fragment key={card.id}>
              <div
                id={`card-${card.id}`}
                key={card.id}
                className={`${classes} paywall print-story-card`}
              >
                {/* {cardAttributeTicker.length ? (
                  <WithMember>
                    {({ checkForMemberUpdated }) => (
                      <MarketBox
                        reloadMember={checkForMemberUpdated}
                        entities={cardAttributeTicker}
                      />
                    )}
                  </WithMember>
                ) : null} */}
                {storyElements.map((element, index) => {
                  const storyElement =
                    storyStyleType === 'cards' ? changeSymbolColor(element) : element;

                  return (
                    <>
                      {storyElementWithCustomTemplates(
                        card,
                        storyElement,
                        story,
                        cardAttributeTemplate
                      )}
                    </>
                  );
                })}
              </div>

              {/* {index === storyCards.length - 2 && (
                <div id="cx_d69ed4036eaf920b54b9197a41ccf409bbd261b3"></div>
              )} */}
              {index === Math.round(cardLength / 2) - 1 && !preview ? (
                <>
                  {/* <div className="responsive-ad content-center mobile-only">
                    <AdWithPlaceholder adtype="ScrollViewArticlePageMobile" height="100px" />
                  </div>
                  <div className="responsive-ad content-center desktop-only">
                    <AdWithPlaceholder adtype="RevealArticlePage" height="90px" />
                  </div> */}
                </>
              ) : (
                ''
              )}
            </React.Fragment>
          );
        })}
      </React.Fragment>
    );
  };

  const textSelection = !props.textSelectionEnabled ? 'disable-selection' : '';
  const datalayerFields = {
    category: 'article page',
    action: 'NA',
    label: props.story.headline,
    event: 'event articlepage',
    cd22: 'link',
    cd23: 'NA', // element location
    cd24: 'NA', // element id
    cd26: syndicatedSource(props.story),
    cd31: props.story['story-template'] || 'text',
    cd35: 'NA', // recommendation engine
    cd34: 'NA', // source of the user
  };
  const audioS3Key = get(props, ['story', 'story-audio', 's3-key']);

  const getHeroImageCaption = () => {
    let heroImageCaption =
      get(props, ['story', 'hero-image-caption'], null) ||
      get(
        props,
        ['story', 'alternative', 'home', 'default', 'hero-image', 'hero-image-caption'],
        ''
      );

    heroImageCaption =
      heroImageCaption &&
      heroImageCaption
        .replace(/<div class="paragraphs"><p>/gi, '')
        .split('</p></div>')
        .join(' ')
        .split('<br>')
        .join(' ');

    return heroImageCaption ? (
      <div styleName="hero-image-caption" dangerouslySetInnerHTML={{ __html: heroImageCaption }} />
    ) : (
      <></>
    );
  };

  const PublisherAndSocialShareSection = () => {
    return (
      <div>
        <div
          styleName={
            props.amazon_polly && audioS3Key
              ? 'story-content-head story-content-head-inc-margin'
              : 'story-content-head'
          }
        >
          <div styleName="clock-icon-border" className="desktop-only">
            <ClockOutlineIcon size="24px" color="var(--regent-gray)" />
          </div>
          <div styleName="clock-icon-mobile" className="mobile-only">
            <ClockOutlineIcon size="18px" color="var(--regent-gray)" />
          </div>
          <div styleName="author-and-published-time">
            <span className="desktop-only">Updated On</span>
            <span
              styleName="story-published-date"
              dateTime={new Date(props.story['last-published-at'])
                .toISOString()
                .replace('Z', '+05:30')}
            >
              {getStoryDate(props.story['last-published-at'])}{' '}
              <span className="icon-ic_info_outline" styleName="story-date-info-icon"></span>
              <div styleName="popover-story-dates">
                <PublishedInfo
                  publishedAt={props.story['first-published-at']}
                  updatedAt={props.story['last-published-at']}
                />
              </div>
            </span>
          </div>
          {/* <PublishedInfo
            publishedAt={props.story['first-published-at']}
            updatedAt={props.story['last-published-at']}
          /> */}
          {props.amazon_polly && audioS3Key && (
            <WithMember>
              {({ member, checkForMemberUpdated }) => (
                <AmazonPolly
                  member={member}
                  checkForMemberUpdated={checkForMemberUpdated}
                  hasAccess={!props.partialAccess}
                  story={props.story}
                />
              )}
            </WithMember>
          )}

          {/* Social share option beside author details mobile view */}
          {/* <MediaQuery maxWidth={767}>
            <Share
              datalayerFields={datalayerFields}
              title={props.story.headline}
              url={props.story.slug}
              summary={props.story.summary}
              services={['whatsapp', 'twitter', 'facebook', 'linkedin', 'copy']}
              alignType="verticle"
              onClick={storyShareClickHandler(
                props.story['story-content-id'],
                `${props.publisherUrl}/${props.story.slug}`
              )}
            />
          </MediaQuery> */}

          {/* Social share toggle option floating in mobile */}
          {/* <MediaQuery maxWidth={767}>
            <ShareToggle
              showAlways={true}
              storyId={props.story.id}
              datalayerFields={datalayerFields}
              title={props.story.headline}
              url={props.story.slug}
              summary={props.story.summary}
              services={['whatsapp', 'twitter', 'facebook', 'telegram', 'linkedin', 'copy']}
              servicesToShowByDefault={2}
              alignType="verticle"
              showToggleWhenExpanded={false}
              onClick={storyShareClickHandler(
                props.story['story-content-id'],
                `${props.publisherUrl}/${props.story.slug}`
              )}
            />
          </MediaQuery> */}

          {/* Social share option beside author details */}
          <div styleName="share-floating-expanded">
            <img
              src={props?.googlenews_icon}
              title="Google News"
              height="46vw"
              alt="google-news-follow"
              onClick={() =>
                window.open(
                  'https://news.google.com/publications/CAAqBwgKMKr0kAsw9JylAw?hl=en-IN&gl=IN&ceid=IN%3Aen',
                  '_blank'
                )
              }
            />
            <Share
              datalayerFields={datalayerFields}
              title={props.story.headline}
              url={props.story.slug}
              summary={props.story.summary}
              services={['whatsapp', 'twitter', 'facebook', 'telegram']}
              onClick={storyShareClickHandler(
                props.story['story-content-id'],
                `${props.publisherUrl}/${props.story.slug}`
              )}
              source="story-content-head"
              expanded={true}
              alignType="horizontal"
              showToggleWhenExpanded={false}
              bookmark={props.bookmark}
              storyId={get(props, ['story', 'id'])}
            />
          </div>

          {/* Social share option floating top */}
          {showFloatingSocial ? (
            <ShareFloatingExpanded
              datalayerFields={datalayerFields}
              title={props.story.headline}
              url={props.story.slug}
              summary={props.story.summary}
              services={['whatsapp', 'twitter', 'facebook', 'telegram', 'copy']}
              onClick={storyShareClickHandler(
                props.story['story-content-id'],
                `${props.publisherUrl}/${props.story.slug}`
              )}
              storyId={get(props, ['story', 'id'])}
              bookmark={props.bookmark}
              story={props.story}
            />
          ) : null}
        </div>
      </div>
    );
  };

  // const isDavosStory = get(props, ['story', 'sections'])
  //   .map(item => item.slug)
  //   .includes('davos-world-economic-forum-2023');

  // const isBudgetStory = get(props, ['story', 'sections'])
  //   .map(item => item.slug)
  //   .includes('budget-2023');

  const isExclusive = get(props, ['story', 'tags'], [])?.some((tag) => tag.name === 'bqblue');

  const [stories, setStories] = useState([]);

  const noHeroImage = get(props, ['story', 'hero-image-s3-key']) === null ||
    (!isEmpty(get(props, ['story', 'alternative'])) && !!get(props, ['story', 'alternative', 'home', 'default', 'hero-image', 'hero-image-s3-key']));

  // const isLiveBlog = get(props, ['story', 'story-template']) === 'live-blog';

  const SLIDER_SETTINGS = {
    dots: false,
    infinite: true,
    speed: 1500,
    slidesToShow: 4,
    slidesToScroll: 4,
    focusOnSelect: false,
    autoplay: false,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
          slidesToScroll: 4,
        },
      },
    ],
    nextArrow: (
      <div>
        <RightArrowSmall color="fourth-color" />
      </div>
    ),
    prevArrow: (
      <div>
        <LeftArrowSmall color="fourth-color" />
      </div>
    ),
  };

  useEffect(() => {
    fetch(
      `${props?.integrations?.['market-api']?.['client-host']}/feapi/markets/indices/indian-indices?duration=1D`
    )
      .then((res) => res.json())
      .then((res) => setTopIndices(res?.data));

    fetch(`/api/v1/collections/must-watch-videos?limit=4`)
      .then((res) => res.json())
      .then((res) => {
        setStories(res.items.map((item) => item.story));
      });
    fetch('/api/v1/collections/premium?item-type=story')
      .then((res) => res.json())
      .then((res) => {
        setPremium(res);
      });
  }, []);

  return (
    <>
      <BreadcrumbBasic story={props?.story} />
      {/* {isBudgetStory && <SponsorsBand />} */}
      {/* {isDavosStory && <DavosBand />} */}
      <article id={`story-${props.story.id}`}>
        <>
          {!isGeoBlock && (
            <div styleName="story-content" className={textSelection}>
              <div styleName="story-header-text premium-container">
                {isExclusive ? (
                  <div styleName="heading">
                    <span styleName="title">{getSection(props?.story) || 'Exclusive'}</span>
                    {isStoryExclusive(props?.story) && (<img src="/icons/premium.svg" height="29px" width="auto" />)}
                  </div>
                ) : null}
                <h1 styleName="story-headline">{props.story.headline}</h1>

                <div styleName="story-subtext-wrapper">
                  <h3 styleName="story-subtext">{props.story.summary}</h3>
                  {(hasSection(props.story.sections, 'View') ||
                    hasSection(props.story.sections, 'Gadfly') ||
                    hasSection(props.story.sections, 'Opinion')) && (
                    <OpinionBadge story={props.story} />
                  )}
                </div>
                <div styleName="author-section-premium">
                  <Authors
                    storyId={props.story.id}
                    authors={props.story.authors}
                    datalayerFields={datalayerFields}
                    alt="BQ"
                  />
                </div>
                <TrackVisibility
                  onHide={() => setShowFloatingSocial(true)}
                  onVisible={() => setShowFloatingSocial(false)}
                >
                  <div className="dummy-div-for-intersection-obeserver"></div>
                </TrackVisibility>
              </div>
              <div styleName="premium-container publisher-section-premium">
                {PublisherAndSocialShareSection()}
              </div>
            </div>
          )}
        </>
        <div styleName="story-except-headline" className="container">
          {topIndices && topIndices.length > 0 ? (
            <div styleName="top-indices">
              <h4 styleName="top-indices-title">TOP INDICES</h4>
              <div styleName="indices"></div>
              {topIndices?.slice(0, 5)?.map((indice, index) => {
                const percentage = get(indice, ['price-movement', 'chgp'], '');
                const currentPrice = get(indice, ['price-movement', 'current-price'], '');
                return (
                  <BQLink href={'/markets?src=strypge'}>
                    <div styleName="indice">
                      <h5 style={{ fontFamily: 'var(--font3)' }}>{indice.name}</h5>
                      <div styleName="indice-movement">
                        <div>
                          <span
                            style={{
                              color: percentage > 0 ? 'var(--success-color)' : 'var(--primary)',
                              fontFamily: 'var(--font3)',
                            }}
                          >
                            <SvgIcon
                              type={`${percentage > 0 ? 'upArrowCircle' : 'downArrowCircle'}`}
                              source="image"
                              height="13"
                              width="13"
                            />
                            {Number(currentPrice).toFixed(2)}
                          </span>
                        </div>
                        <span style={{ fontFamily: 'var(--font3)' }}>
                          {percentage > 0
                            ? `+${Number(percentage).toFixed(2)}`
                            : Number(percentage).toFixed(2)}
                          %
                        </span>
                      </div>
                    </div>
                  </BQLink>
                );
              })}
            </div>
          ) : (
            <div />
          )}
          <div styleName="left-sidebar">
            {/* disable telegram instant view */}
            <div className="reddit-card " />
            <div className="reddit-embed" />
            <canvas className="hide-element" width="1" height="1" />
            <object className="hide-element" width="1" height="1" />
            {/* disable telegram instant view */}
            {/* <Header story={props.story} /> */}
            <>
              <div styleName="story-header">
                {!isGeoBlock && !noHeroImage && (
                  <div styleName="shimmer-card">
                    <div styleName="hero-image-container">
                      <CardImage
                        story={props.story}
                        aspectRatio={[16, 9]}
                        imageType="image5x2"
                        showHeroDetails={true}
                        isLazy={false}
                      />
                      {getHeroImageCaption()}
                    </div>
                  </div>
                )}

                {!isGeoBlock ? (
                  <div styleName={`body-container ${noHeroImage ? 'mt-neg' : ''}`}>
                    {/* <div
                      id="piano-preview-story"
                      styleName="piano-preview-story"
                      style={{ display: 'none' }}
                    >
                      {props.previewContent}
                    </div> */}
                    <div>{renderCards(props?.story, props?.story?.cards)}</div>
                    {/* {props.isLoading ? (
                      <div styleName="loader-container">
                        <Loader width="66" color="#f86d1a" />
                      </div>
                    ) : (
                      <div />
                    )} */}
                    {/* <PianoPaywall /> */}
                    <div className="mobile-only">
                      <MailmodoNewsLetter
                        heading="Get market moving news, top news & compelling perspectives"
                        footerText1="We Promise. No Spam !"
                        footerText2="View All Newsletters"
                        page="story"
                        checkStory={true}
                      />
                    </div>
                  </div>
                ) : (
                  <div styleName="body-container">
                    <ContentNotAvailable />
                  </div>
                )}
              </div>
            </>
            <div style={{ position: 'sticky', top: '100px' }}>
              <Footer
                {...props}
                PublisherAndSocialShareSection={PublisherAndSocialShareSection}
                isGeoBlock={isGeoBlock}
                isPremiumTemplate={true}
              />
            </div>
            {stories && (
              <>
                <div className="desktop-only" styleName="desktop-videos-section">
                  <div className="desktop-only" style={{ position: 'relative' }}>
                    <MailmodoNewsLetter
                      heading="Get market moving news, top news & compelling perspectives"
                      footerText1="No Spam. Just great journalism in your inbox"
                      footerText2="View All Newsletters"
                      page="story"
                      checkStory={true}
                    />
                  </div>
                  <VideoTitle />
                  <Slider {...SLIDER_SETTINGS}>
                    {stories.slice(0, 4).map((story) => {
                      return (
                        story && (
                          <div styleName="story-container" key={story.id}>
                            <StoryCardVerticalWithImageDate
                              story={story}
                              imageType="image6x4"
                              aspectRatio={[6, 4]}
                            />
                          </div>
                        )
                      );
                    })}
                  </Slider>
                </div>
                <div className="mobile-only" styleName="story-bottom-videos">
                  {stories.length > 0 && <VideosWidget stories={stories} />}
                </div>
              </>
            )}
          </div>
          <div id="top-five-stories-today" styleName="top-five-stories-today">
            <MoreLikeThisWidget story={props.story} type="premium" />
          </div>
        </div>
      </article>
      {premium && (
        <div id="exclusives-premium-section" className="container">
          <ExclusivesStorySliderWidget collection={premium} />
        </div>
      )}
    </>
  );
};

PremiumStory.propTypes = {
  publisherUrl: string.isRequired,
  story: objectOf(any).isRequired,
  content: element.isRequired,
  textSelectionEnabled: bool.isRequired,
  cardOrder: string,
  orderChanged: func,
  isLoading: bool,
  amazon_polly: bool,
  bookmark: bool,
};

PremiumStory.defaultProps = {
  cardOrder: '',
  orderChanged: () => {},
};

const mapStateToProps = (state) => ({
  publisherUrl: state.qt.config['sketches-host'],
  integrations: state.qt.config.integrations,
  textSelectionEnabled: state.qt.config.features.story.text_selection.enabled,
  juspayMicroFlow: state.qt.config.features.subscription.juspay_micro,
  amazon_polly: get(state.qt, ['config', 'features', 'amazon_polly', 'enabled'], false),
  bookmark: get(state, ['qt', 'config', 'features', 'bookmark', 'enabled'], false),
  googlenews_icon: get(state, ['qt', 'config', 'publisher', 'cdn-images', 'googlenews'], ''),
});

export default connect(mapStateToProps, {})(PremiumStory);
